import React, { useState } from "react";
import Button from "Components/UI/Button/Button";
import { Input, Switch } from "antd";
import { FilterItemProps } from "Components/PageTable/PageTable";
import styled from "./Brokerage.module.scss";

const Brokerage: React.FC<FilterItemProps> = ({ openStateToggler: toggleOpenState }) => {
  const [mode, setMode] = useState("inline");
  const changeMode = () => {
    setMode(mode ? "vertical" : "inline");
  };
  return (
    <div className={styled.container}>
      <div className={styled.container__backg}>
        <h4 className={styled.container__backg__text}>Broker name </h4>
        <div className={styled.container__backg__registr}>
          <Input
            defaultValue="Start input..."
            className={styled.container__backg__registr_input}
          />
        </div>

        <Button
          className={styled.container__backg_btn}
          onClick={toggleOpenState}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default Brokerage;
